
























import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

@Component
export default class extends Mixins(AxPage) {}
